import { render, staticRenderFns } from "./proSwiper.vue?vue&type=template&id=4a1c8de3&"
import script from "./proSwiper.vue?vue&type=script&lang=js&"
export * from "./proSwiper.vue?vue&type=script&lang=js&"
import style0 from "./proSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/index/proSwiper.vue
// module id = null
// module chunks = 